export default "__VITE_ASSET__ax6Se7tc__"